import Swiper from 'swiper/bundle';
export default class Carousel {
  constructor(element) {
    this.element = element;
    this.options = {
      loop: false,
      autoplay: false,
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: this.element.querySelector('.swiper-pagination'),
      },
      navigation: {
        nextEl: this.element.querySelector('.swiper-button-next'),
        prevEl: this.element.querySelector('.swiper-button-prev'),
      },
    };
    this.init();
  }
  setOptions() {
    if ('loop' in this.element.dataset) {
      this.options.loop = true;
      this.options.spaceBetween = 0;
    }
    if ('view' in this.element.dataset) {
      this.options.slidesPerView = this.element.dataset.view;
      this.options.breakpoints = {
        1024: {
          slidesPerView: 3,
        },
      };
    }
    if ('autoplay' in this.element.dataset) {
      this.options.autoplay = {
        options: true,
        delay: 3000,
        pauseOnMouseEnter: false,
        disableOnInteraction: false,
      };
    }
    if ('slides' in this.element.dataset) {
      this.options.slidesPerView =
        parseFloat(this.element.dataset.slides) || this.options.slidesPerView;
    }
    if ('service' in this.element.dataset) {
      (this.options.spaceBetween = 40),
        (this.options.breakpoints = {
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 40,
          },
        });
    }
    if ('fullSize' in this.element.dataset) {
      this.options.spaceBetween = 100;
    }
  }

  init() {
    this.setOptions();
    console.log('test');
    const swiper = new Swiper(this.element, this.options);
  }
}
